import { ChainId } from 'nightmare-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.FTMTESTNET]: '0x51212a2164Cc5F2715230773654D4Be51CBF6449', //  TODO: CHANGE THIS
  [ChainId.MAINNET]: '0xc7efb32470dEE601959B15f1f923e017C6A918cA',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
